import { useActivitySessionSendToUnsubmitted } from 'src/generated/endpoint';

export const useTeacherActivitySessionUnsubmitterNotificate = ({
  sessionId,
  onSuccess,
  onError,
}: {
  sessionId: number;
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const { mutateAsync: sendToUnsubmitted } = useActivitySessionSendToUnsubmitted();

  const handleSendToUnsubmitted = async () => {
    try {
      const result = await sendToUnsubmitted({ id: sessionId });

      if (result) {
        onSuccess?.();
      } else {
        onError?.();
      }
    } catch (error) {
      onError?.();
    }
  };

  return { handleSendToUnsubmitted };
};
